import state from "./state";
import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

/** Tab module. */
export const tabModule = {
    state,
    getters,
    mutations,
    actions,
};
